// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3Uu5L","amount":"Amount_amount__ZDGIG","tip":"Amount_tip__1AePI","tipHeader":"Amount_tipHeader__IfuOx","tipsWrap":"Amount_tipsWrap__q33EX"};